import React, {FormEvent, useState} from 'react';
import styles from './comments.module.scss';
import {Form, FormGroup, FormLabel, FormText, Modal, ModalBody, ModalHeader} from "react-bootstrap";
import {useDispatch} from "react-redux";
import {ALERT} from "@/actions/types";
import axios from "@/app/axios";
import { nl2p } from '@/app/general';

type Props = {
    comments: IComment[] | undefined,
    postId: number
};

type AddComment = {
  replyTo?: number;
  name: string;
  text: string;
  email: string
};

const Comments: React.FC<Props> = ({ comments, postId }) => {
    const [replyInfo, setReplyInfo] = useState<AddComment>({
        replyTo: undefined,
        name: "",
        text: "",
        email: ""
    });
    const [showCommentModal, setShowCommentModal] = useState(false);
    const addComment = (commentId?: number) => {
        setReplyInfo({...replyInfo, replyTo: commentId});
        setShowCommentModal(true);
    };

    const closeModal = () => {
        setShowCommentModal(false);
    };

    const CommentItems: React.FC<Props> = ({ comments }) => (
        <div className={styles.comments}>
            {comments?.map((comment, idx) => (
                <div key={'comment' + comment.id + Math.random()} className={styles.comment}>
                    <div className={styles.image}>
                        <img src={comment.writer.avatar} alt={comment.writer.name} />
                    </div>
                    <div className={styles.content}>
                        <div className={styles.text}>
                            <div className={styles.descriptionHeader}>
                                <h5>{comment.writer.name}</h5>
                                <span className={styles.time}>{comment.date}</span>
                            </div>
                            {nl2p(comment.text)}
                            <div className={styles.reply}>
                                <button type="button" className="btn btn-secondary" onClick={() => addComment(comment.id)}>پاسخ دادن</button>
                            </div>
                        </div>
                        {comment.replies.length ? (
                            <div className={styles.replies}>
                                <CommentItems comments={comment.replies} postId={postId} />
                            </div>
                        ) : ''}
                    </div>
                </div>
            ))}
        </div>
    );

    const dispatch = useDispatch();

    const submitComment = (e: FormEvent) => {
        e.preventDefault();
        if(replyInfo.name.trim().length < 3) {
            return dispatch({
                type: ALERT,
                payload: { message: { result: 0, message: 'لطفا نام خود را بطور کامل وارد نمایید.' } }
            });
        }
        if(replyInfo.email.length < 3) {
            return dispatch({
                type: ALERT,
                payload: { message: { result: 0, message: 'ایمیل بدرستی وارد نشده است.' } }
            });
        }
        if(replyInfo.text.length < 4 || replyInfo.text.length > 500) {
            return dispatch({
                type: ALERT,
                payload: { message: { result: 0, message: 'طول پیام نمیبایست بیش از ۵۰۰ کاراکتر و یا کمتر از ۴ کاراکتر باشد.' } }
            });
        }
        axios.post('api/add-comment/'+postId, {...replyInfo}).then((res) => {
            dispatch({
                type: ALERT,
                payload: { message: { ...res.data } }
            });
            closeModal();
        }).catch(err => {
            const result = err.response.data || { result: 0, message: "خطای نامشخص" };
            dispatch({
                type: ALERT,
                payload: { result: 0, message: result }
            });
        });
    }

  return (
    <div className={styles.postComments}>
        <div className={styles.header}>
        <h4>
          <i className="fa fa-comments" /> <span>نظرات</span>
        </h4>
      </div>
        <div className={styles.addComment + " mb-4"}>
            {!comments || !comments.length ? (
                <span>اولین ارسال کننده نظر شما باشید!</span>
            ) : ''} { ' ' }
            <button className="btn btn-primary" onClick={() => addComment()}>ارسال نظر</button>
        </div>
        <CommentItems comments={comments} postId={postId} />
        <Modal className={styles.modal} show={showCommentModal} onHide={() => setShowCommentModal(false)}>
            <ModalHeader>
                <h5>ارسال نظر</h5>
            </ModalHeader>
            <ModalBody>
                <Form method="post" onSubmit={submitComment}>
                    <FormGroup className="mb-3">
                        <FormLabel>نام *</FormLabel>
                        <input name="name" className="form-control" placeholder="نام کامل" value={replyInfo.name} onChange={(e) => setReplyInfo({...replyInfo, name: e.target.value})} />
                    </FormGroup>
                    <FormGroup className="mb-3">
                        <FormLabel>ایمیل *</FormLabel>
                        <input name="email" className="form-control" placeholder="ایمیل(نمایش داده نخواهد شد)" value={replyInfo.email} onChange={(e) => setReplyInfo({...replyInfo, email: e.target.value})} />
                    </FormGroup>
                    <FormGroup className="mb-3">
                        <FormLabel>نظر *</FormLabel>
                        <textarea name="text" className="form-control" placeholder="متن نظر" value={replyInfo.text} onChange={(e) => setReplyInfo({...replyInfo, text: e.target.value})} />
                    </FormGroup>
                    <FormGroup>
                        <button className="btn btn-primary" type="submit">
                            ارسال نظر
                        </button>
                        <button className="btn btn-danger float-start" type="button" onClick={() => setShowCommentModal(false)}>
                            بیخیال
                        </button>
                    </FormGroup>
                </Form>
            </ModalBody>
        </Modal>
    </div>
  );
}

export default Comments;
